import { collection, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { useParams } from "react-router-dom";

import { Alert, Button, Card, Col, DatePicker, Form, Row, message } from "antd";

import React, { useState } from "react";
import moment from "moment";
import dayjs from "dayjs";
function Compliance({ data, renderData, company }) {
  const [checked, setChecked] = useState(false);

  const { id } = useParams();
  const dateFormat = "DD-MM-YYYY";
  const today = moment().startOf("day");
  const onFinish = async (values) => {
    console.log("Success:", values);
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, company);
    const vendorRef = collection(companyDocRef, "vendors");

    Object.keys(values).forEach((key) => {
      const value = values[key];
      if (value === undefined) {
        values[key] = "";
        // Convert Date to formatted string
      } else if (value instanceof Date) {
        values[key] = value.format("DD-MM-YYYY");
      }
    });
    try {
      await updateDoc(doc(vendorRef, id), {
        compliance: {
          workerCompExpiration: values["workerCompExpiration"]
            ? values["workerCompExpiration"].format("DD-MM-YYYY")
            : "",
          liabilityInsuranceExpiration: values["liabilityInsuranceExpiration"]
            ? values["liabilityInsuranceExpiration"].format("DD-MM-YYYY")
            : "",
          EPACertificationExpiration: values["EPACertificationExpiration"]
            ? values["EPACertificationExpiration"].format("DD-MM-YYYY")
            : "",
          autoInsuranceExpiration: values["autoInsuranceExpiration"]
            ? values["autoInsuranceExpiration"].format("DD-MM-YYYY")
            : "",
          stateLicenseExpiration: values["stateLicenseExpiration"]
            ? values["stateLicenseExpiration"].format("DD-MM-YYYY")
            : "",
          contractExpiration: values["contractExpiration"]
            ? values["contractExpiration"].format("DD-MM-YYYY")
            : "",
        },
      });

      message.success("Compliance Setting updated successfully..", 3);
      renderData(true);
      setChecked(false);
    } catch (err) {
      message.error("Something is went wrong!", 3);

      console.error(err);
      alert(err.message);
    }
  };

  const defaultValues = {
    workerCompExpiration: dayjs(data?.workerCompExpiration, dateFormat),
    liabilityInsuranceExpiration: dayjs(
      data?.liabilityInsuranceExpiration,
      dateFormat
    ),
    EPACertificationExpiration: dayjs(
      data?.EPACertificationExpiration,
      dateFormat
    ),
    autoInsuranceExpiration: dayjs(data?.autoInsuranceExpiration, dateFormat),
    stateLicenseExpiration: dayjs(data?.stateLicenseExpiration, dateFormat),
    contractExpiration: dayjs(data?.contractExpiration, dateFormat),
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Something is went wrong!", 3);
  };
  const checkExpiry = (date, message) => {
    const currentDate = moment().startOf("day");
    const expirationDate = moment(date, "DD-MM-YYYY");

    if (currentDate.isAfter(expirationDate, "day")) {
      return (
        <Alert
          message={`${date} ${message}`}
          type="warning"
          showIcon
          style={{ width: "400px" }}
        />
      );
    } else {
      return date;
    }
  };
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Compliance"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <div>
              <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 11 }}
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={defaultValues}
              >
                <Col span={24}>
                  <Form.Item
                    label="Workers' Comp. Expiration"
                    name="workerCompExpiration"
                  >
                    <DatePicker style={{ width: "100%" }} format={dateFormat} />
                  </Form.Item>
                  <Form.Item
                    label="General Liability Expiration"
                    name="liabilityInsuranceExpiration"
                  >
                    <DatePicker style={{ width: "100%" }} format={dateFormat} />
                  </Form.Item>
                  <Form.Item
                    label="EPA Certification Expiration"
                    name="EPACertificationExpiration"
                  >
                    <DatePicker style={{ width: "100%" }} format={dateFormat} />
                  </Form.Item>
                  <Form.Item
                    label="Auto Insurance Expiration"
                    name="autoInsuranceExpiration"
                  >
                    <DatePicker style={{ width: "100%" }} format={dateFormat} />
                  </Form.Item>
                  <Form.Item
                    label="State License Expiration"
                    name="stateLicenseExpiration"
                  >
                    <DatePicker style={{ width: "100%" }} format={dateFormat} />
                  </Form.Item>
                  <Form.Item
                    label="Contract Expiration"
                    name="contractExpiration"
                  >
                    <DatePicker style={{ width: "100%" }} format={dateFormat} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Row gutter={[8, 0]}>
                    <Col>
                      <Button type="primary" htmlType="submit">
                        Save
                      </Button>
                    </Col>
                    <Col>
                      <Button onClick={() => setChecked(false)}>Cancel</Button>
                    </Col>
                  </Row>
                </Col>
              </Form>
            </div>
          ) : (
            <Form colon={false} labelCol={{ span: 7 }} wrapperCol={{ span: 5 }}>
              <Form.Item label="Workers' Comp. Expiration">
                <p>
                  {checkExpiry(
                    data?.workerCompExpiration,
                    "Worker's Comp.Expired."
                  )}
                </p>
              </Form.Item>
              <Form.Item label="General Liability Expiration">
                <p>
                  {checkExpiry(
                    data?.liabilityInsuranceExpiration,
                    "General Liability Expired."
                  )}
                </p>
              </Form.Item>
              <Form.Item label="EPA Certification Expiration">
                <p>
                  {checkExpiry(
                    data?.EPACertificationExpiration,
                    "EPA Certification Expired."
                  )}
                </p>
              </Form.Item>
              <Form.Item label="Auto Insurance Expiration">
                <p>
                  {checkExpiry(
                    data?.autoInsuranceExpiration,
                    "Auto Insurance Expired."
                  )}
                </p>
              </Form.Item>
              <Form.Item label="State License Expiration">
                <p>
                  {checkExpiry(
                    data?.stateLicenseExpiration,
                    "State License Expired."
                  )}
                </p>
              </Form.Item>
              <Form.Item label="Contract Expiration">
                <p>
                  {checkExpiry(data?.contractExpiration, "Contract Expired.")}
                </p>
              </Form.Item>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default Compliance;
